import { Component, OnDestroy, OnInit } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { merge, of, OperatorFunction, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'tax-login-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.sass'],
})
export class LoginSidebarComponent implements OnInit, OnDestroy {
  activeMenuItem?: 'login' | 'registration';
  registrationStep?: 1 | 2;

  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.setActiveMenuItem();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  private setActiveMenuItem(): void {
    merge(
      of(this.router.routerState.snapshot),
      this.router.events.pipe(filter(event => (event instanceof NavigationEnd)) as OperatorFunction<Event, NavigationEnd>),
    )
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        this.activeMenuItem = result.url.split('/')[2] === 'registration' ? 'registration' : 'login';

        const step: string = result.url.split('/')[3]?.split('?')[0];
        switch (step) {
          case 'select-eds':
          case 'add-phone':
            this.registrationStep = 1; break;
          case 'fill-form':
            this.registrationStep = 2; break;
          default:
            this.registrationStep = undefined;
        }
      });
  }

  goToRegistrationSelectEds() {
    if (this.activeMenuItem !== 'registration') {
      this.router.navigateByUrl('/landing/registration/select-eds');
    }
  }

}
